module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__form-group-item"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "firm"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n            Firma / Organisation\n        ")]), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "required-symbol"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("(Pflichtfeld)")])]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.form[_vm.$parent.address].company),
      expression: "$parent.form[$parent.address].company",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.required ? _vm.$parent.$v.form[_vm.$parent.address].company.$error : ''
    },
    attrs: {
      "type": "text",
      "name": "firm"
    },
    domProps: {
      "value": (_vm.$parent.form[_vm.$parent.address].company)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.form[_vm.$parent.address], "company", $event.target.value.trim())
      }, function($event) {
        _vm.required ? _vm.$parent.$v.form[_vm.$parent.address].company.$touch() : ''
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1c7e186","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/Firm.vue
// module id = 805
// module chunks = 0